export default __webpack_public_path__ + "static/media/client4.709658cb.png";